import { View } from "@-/com.npmjs.react-native";
import { Surface } from "@-/dev.improve.haniverse.components.ui.surface";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { Level } from "@-/dev.improve.haniverse.lib.level";
import { LevelSurfaceHeader } from "@-/dev.improve.haniverse.routes.nav.app._components.level.surface";
import split from "@-/com.npmjs.just-split";
import { LockedLevelBlur } from "#locked-level-blur";

/** One blur target per body: the header and upgrade action always stay sharp. */
export function LockedLevelSurface({
  characters: charactersProp,
  columns,
  label,
  level,
}: {
  /** The lessons (surface squares) the level shows; defaults to its characters. */
  characters?: readonly string[];
  columns: number;
  /** The title; defaults to `Level N`. */
  label?: string;
  level: Level;
}) {
  const characters = charactersProp ?? level.characters;
  return (
    <Surface
      className="mb-1"
      testID={
        label === undefined
          ? `locked-level-${level.index + 1}`
          : `locked-${label.toLowerCase().replaceAll(" ", "-")}`
      }
    >
      <LevelSurfaceHeader characters={characters} label={label} level={level} />
      <LockedLevelBlur>
        <View aria-hidden className="gap-1 p-1">
          {split([...characters], columns).map((row, rowIndex) => (
            <View className="flex-row gap-1" key={rowIndex}>
              {Array.from({ length: columns }, (_, column) => (
                <View
                  className="aspect-square min-w-0 flex-1 items-center justify-center"
                  key={column}
                >
                  {row[column] === undefined ? null : (
                    <View className="size-full items-center justify-center rounded-xs border border-border">
                      <Text className="text-2xl text-foreground/70">{row[column]}</Text>
                    </View>
                  )}
                </View>
              ))}
            </View>
          ))}
        </View>
      </LockedLevelBlur>
    </Surface>
  );
}
